import serverConnection from '../common/server-connection.js';

export default function() {
    $('.mi-character-icon').on('click', function (e) {
      $('.character-popup img.mi-character-icon').attr('src', $(e.target).attr('src'));
      $('.character-popup .character-into-content').html($(e.target).parents('.character').find('.character-introduction').html());
      $('.character-popup').addClass('show');
      $('body').addClass('no-overflow');
    })

    $('.popup-overlay').on('click', function () {
      $('.character-popup').removeClass('show');
      $('body').removeClass('no-overflow');
    });

    $(document).keyup(function (e) {
      if (e.keyCode == 27) {
          $('.character-popup').removeClass('show');
          $('body').removeClass('no-overflow');
      }
    });
}


// WEBPACK FOOTER //
// app/javascript/src/javascripts/page/characters.js